import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { removeToast } from "../../store/reducers/toasterReducer";
import "./Toaster.scss";

const Toaster = () => {
  const dispatch = useDispatch();
  const toasts = useSelector((state) => state.toaster.toasts);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    const timers = toasts.map((toast, index) => {
      if (hoveredIndex === index) return null;

      return setTimeout(() => {
        dispatch(removeToast(toast.id)); 
      }, 3000);
    });

    return () => {
      timers.forEach((timer) => timer && clearTimeout(timer));
    };
  }, [toasts, dispatch, hoveredIndex]);

  const handleRemoveToast = (id) => {
    dispatch(removeToast(id));
  };

  return (
    <div className="toaster-container">
      {toasts.map((toast, index) => (
        <div
          key={toast.id}
          className={`toaster ${toast.type}`}
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          {toast.message}
          <button
            className="close-btn"
            onClick={() => handleRemoveToast(toast.id)}
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  );
};

export default Toaster;
